/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type RenderItemEmailInput = {
    readonly itemId: string;
    readonly message?: string | null;
    readonly recipientEmails: ReadonlyArray<string | null>;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly clientMutationId?: string | null;
};
export type RenderItemEmailMutationVariables = {
    readonly input: RenderItemEmailInput;
};
export type RenderItemEmailMutationResponse = {
    readonly renderItemEmail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RenderItemEmailMutation = {
    readonly response: RenderItemEmailMutationResponse;
    readonly variables: RenderItemEmailMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "RenderItemEmailInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "renderItemEmail",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RenderItemEmailPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RenderItemEmailMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "RenderItemEmailMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "RenderItemEmailMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/RenderItemEmailMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c58daa30a2a98ff34ccaa9b704be671d';
export default node;
